"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ScheduledEditBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _scheduledMessages = require('shared/services/scheduledMessages');










// Above the field while a scheduled message's text is in it: Save (the Send
// button) keeps its time. A stale save says who changed it, with Reload.
// Rescheduling a failed message says so, and why it wasn't sent; its Send
// button (Reschedule) picks the new time.
const ScheduledEditBar = ({ editing, timeZone, onReload, onStop }) => {
  const text = _scheduledMessages.scheduledEditBarText.call(void 0, editing, undefined, timeZone)
  return (
    _react2.default.createElement('div', { className: "scheduled-edit-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
      , _react2.default.createElement('i', { className: "material-icons scheduled-edit-bar--icon" , 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}, "schedule")
      , _react2.default.createElement('div', { className: "scheduled-edit-bar--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
        , _react2.default.createElement('span', { className: "scheduled-edit-bar--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}, text.title)
        , _react2.default.createElement('span', { className: "scheduled-edit-bar--time", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}, text.detail)
        , editing.error && _react2.default.createElement('span', { role: "alert", className: "scheduled-edit-bar--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}, editing.error)
      )
      , editing.latest && (
        _react2.default.createElement('button', { type: "button", className: "scheduled-edit-bar--reload", onClick: onReload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}, "Reload")
      )
      , _react2.default.createElement('button', { type: "button", className: "scheduled-edit-bar--close", 'aria-label': text.stopLabel, onClick: onStop, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
        , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}, "close")
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ScheduledEditBar)
